<aside class="main-sidebar sidebar-dark-primary elevation-4">
    <a routerLink="home" class="brand-link">
      	<img src="assets/dist/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
           	style="opacity: .8">
      	<span class="brand-text font-weight-light">CFD_RTC</span>
    </a>

    <div class="sidebar">
      	<div class="user-panel mt-3 pb-3 mb-3 d-flex">
        	<div class="image">
          		<img src="assets/dist/img/user.png" class="img-circle elevation-2" alt="User Image">
        	</div>
        	<div class="info">
         		 <a routerLink="profile" href="#" class="d-block">{{user.nickname}}</a>
        	</div>
      	</div>
      	<nav class="mt-2">
        	<ul class="nav nav-pills nav-sidebar flex-column" >
          		<li class="nav-item has-treeview " (click)="menu_open(x)"  [ngClass]="x.active?'menu-open':''"  *ngFor="let x of list" style="cursor: pointer;">
            		<a class="nav-link" (click)="x.active=!x.active">
              			<i class="nav-icon fas fa-tachometer-alt"></i>
              			<p *ngIf="x.type*1===0">
                			{{ x.item }} <i class="right fas fa-angle-left"></i>
              			</p>
              			<p *ngIf="x.type*1===1">
                			<a routerLink="{{x.url}}">
                    			{{ x.item }} <i class="right fas fa-angle-left"></i>
                			</a>
              			</p>
            		</a>

					
            		<!-- <ul class="nav nav-treeview" *ngIf="x.type*1===0 && power != 16"> -->
					<ul class="nav nav-treeview" *ngIf="x.type*1===0">
              			<li class="nav-item"  *ngFor="let y of x.subitem" style="cursor: pointer;">
                			<a
                   				[ngClass]="now==y.id?'active':''" 
                    			(click)="now = y.id;menu_hit(y.id);"
                     			class="nav-link" routerLink="{{y.url}}" >
                  				<p>{{ y.item }}</p>
                			</a>
              			</li>
            		</ul>

					<!-- <ul class="nav nav-treeview" *ngIf="x.type*1===0 && power == 16 && isDesktop == true">
						<li class="nav-item"  *ngFor="let y of x.subitem" style="cursor: pointer;">
						  	<a	*ngIf="y.type*1 == 4"
								[ngClass]="now==y.id?'active':''" 
							  	(click)="now = y.id;menu_hit(y.id);"
							   	class="nav-link" routerLink="{{y.url}}" >
								<p>{{ y.item }}</p>
						  	</a>
						</li>
				  	</ul>

					<ul class="nav nav-treeview" *ngIf="x.type*1===0 && power == 16 && isDesktop == false">
						<li class="nav-item"  *ngFor="let y of x.subitem" style="cursor: pointer;">
						  	<a	*ngIf="y.type*1 == 3"
								[ngClass]="now==y.id?'active':''" 
							  	(click)="now = y.id;menu_hit(y.id);"
							   	class="nav-link" routerLink="{{y.url}}" >
								<p>{{ y.item }}</p>
						  	</a>
						</li>
				  	</ul> -->

          		</li>
        	</ul>
      	</nav>
    </div>
    <!-- /.sidebar -->
</aside>
